export const PHID_QUERY_PARAM = "phid";

export const appendPhidToUrl = (url: string, phid: string | null) => {
  if (phid === null || phid.length === 0) {
    return url;
  }
  const parsed = new URL(url);
  parsed.searchParams.set(PHID_QUERY_PARAM, phid);
  return parsed.toString();
};

export const readPhidFromSearch = (search: string) => {
  const value = new URLSearchParams(search).get(PHID_QUERY_PARAM);
  if (value === null || value.length === 0) {
    return null;
  }
  return value;
};
